import { useMemo } from "react";
import { QueryLoader, Grid, AgGridReact, Flex, AgGrid } from "@jsq/ds/core";
import { MinimalQueryResult } from "@jsq/ds/types";
import Titlebar from "~/pages/UserAndRoles/components/Titlebar";

type RoleDetailsTableProps<T> = {
  onGridReady: (event: AgGrid.GridReadyEvent<T>) => void;
  queryResult?: MinimalQueryResult | MinimalQueryResult[];
  title: string;
  columnDefs: AgGridReact.AgGridReactProps["columnDefs"];
  rowData: T[];
  gridOptions: AgGridReact.AgGridReactProps["gridOptions"];
  resetFilters: () => void;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
  isFilterPresent: boolean;
};

export const RoleDetailsTable = <T,>({
  queryResult,
  title,
  columnDefs,
  rowData,
  gridOptions,
  onGridReady,
  resetFilters,
  onFilterChanged,
  isFilterPresent,
}: RoleDetailsTableProps<T>) => {
  const Children = useMemo(() => {
    return (
      <Flex flexDirection="column" flexGrow={1}>
        <Titlebar
          title={title}
          variant="h3"
          marginBottom="lg"
          actionButtons={[
            {
              show: isFilterPresent,
              buttonProps: {
                variant: "neutral",
                icon: "times",
                key: "clear_filters",
                onClick: resetFilters,
                children: "Clear filters",
              },
            },
          ]}
        />
        <Grid
          onGridReady={onGridReady}
          columnDefs={columnDefs}
          rowData={rowData}
          gridOptions={gridOptions}
          onFilterChanged={onFilterChanged}
        />
      </Flex>
    );
  }, [
    title,
    columnDefs,
    rowData,
    gridOptions,
    onGridReady,
    resetFilters,
    onFilterChanged,
    isFilterPresent,
  ]);

  return queryResult ? <QueryLoader result={queryResult}>{Children}</QueryLoader> : Children;
};
